/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faIdBadge} from '@fortawesome/pro-duotone-svg-icons';

const AttendanceIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faIdBadge} {...props} />
);

export default AttendanceIcon;
